module.exports = __webpack_public_path__ + "img/passport.3c30a9b8.jpg";